import { render, staticRenderFns } from "./magazine.vue?vue&type=template&id=71d2cbee&scoped=true&"
import script from "./magazine.vue?vue&type=script&lang=js&"
export * from "./magazine.vue?vue&type=script&lang=js&"
import style0 from "./magazine.vue?vue&type=style&index=0&id=71d2cbee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d2cbee",
  null
  
)

export default component.exports